import { cva, type VariantProps } from 'class-variance-authority';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { haptics } from '../../lib/telegram';

const button = cva(
  // active:scale даёт ощущение нажатия; анимируем только transform — это GPU
  'inline-flex items-center justify-center gap-2 font-medium select-none transition-[transform,opacity,background-color] duration-150 active:scale-[0.97] disabled:opacity-45 disabled:active:scale-100 gpu',
  {
    variants: {
      variant: {
        primary: 'bg-accent text-accent-text',
        secondary: 'bg-surface-2 text-text',
        ghost: 'bg-transparent text-link',
        danger: 'bg-transparent text-danger',
      },
      size: {
        md: 'h-11 px-4 rounded-xl text-[15px]',
        sm: 'h-9 px-3 rounded-lg text-[14px]',
        icon: 'h-9 w-9 rounded-full',
      },
      block: { true: 'w-full', false: '' },
    },
    defaultVariants: { variant: 'primary', size: 'md', block: false },
  },
);

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof button> {
  children?: ReactNode;
  /** нажатие отзывается вибрацией — так приложение ощущается нативным */
  haptic?: 'tap' | 'press' | 'none';
}

export function Button({
  className,
  variant,
  size,
  block,
  haptic = 'tap',
  onClick,
  ...props
}: ButtonProps) {
  return (
    <button
      type="button"
      className={cn(button({ variant, size, block }), className)}
      onClick={(event) => {
        if (haptic === 'tap') haptics.tap();
        else if (haptic === 'press') haptics.press();
        onClick?.(event);
      }}
      {...props}
    />
  );
}
